export const PublicPath = process.env.BASE_PATH || '';
export const Origin = process.env.ORIGIN || '';

export const IsCompleted = false;

export enum SocialId {
    Ok = 'ok',
    Fb = 'fb',
    Tw = 'tw',
    Vk = 'vk',
    Tg = 'tg',
}

export interface StringMap {
    [key: string]: any;
}
